import { CartProduct } from "../product/cart-product/cart-product";
import { CheckPriceProduct } from "../product/check-price-product/check-price-product";

export class OrderItem {

  orderId: number;
  itemNumber: number;
  productId: number;
  productName: string
  classificationId: number;
  classificationName: string;
  quantity: number;
  price: number;
  value: number;
  totalValue: number;
  discountValue: number;
  measurementUnitQuantity: number;
  measurementUnitDescription: string;
  measurementUnitInitials: string;
  listPrice: number;
  cancelledQuantity: number;
  invoicedQuantity: number;
  shippedQuantity: number;
  quantityToShip: number;
  replacedQuantity: number;
  grossAmountInvoiced: number;
  reweightingValue: number;
  packingWeight: number;
  ipiValue: number;
  ipiBaseValue: number;
  stValue: number;
  baseStValue: number;
  stMargin: number;
  ipiPercentage: number;
  stateIcmsBasePercentage: number;
  stateIcmsBaseValue: number;
  stockQuantity: number;
  stateIcmsValue: number;
  targetStateIcmsBasePercentage: number;
  targetStateIcmsBaseValue: number;
  targetStateIcmsPercentage: number;
  targetStateIcmsValue: number;
  taxationId: number;
  // TODO - O que é isso?
  batch: any;

  static fromJson(json: any): OrderItem {
    var temp = new OrderItem();

    temp.orderId = json.ORDERCODE;
    temp.itemNumber = json.ITEMNUMBER;
    temp.productId = json.PRODUCTCODE;
    temp.productName = json.NAME;
    temp.classificationId = json.PRODUCTCLASCODE;
    temp.classificationName = json.CLASNAME;
    temp.quantity = json.QUANTITY;
    temp.price = json.PRICE;
    temp.value = json.VALOR;
    temp.totalValue = json.TOTAL;
    temp.discountValue = json.DISCOUNT;
    temp.measurementUnitQuantity = json.MEASUREMENTUNITQUANTITY;
    temp.measurementUnitDescription = json.MEASUREMENTUNITDESCRIPTION;
    temp.measurementUnitInitials = json.MEASUREMENTUNIT;
    temp.listPrice = json.LISTPRICE;
    temp.cancelledQuantity = json.CANCELEDQUANTITY;
    temp.invoicedQuantity = json.INVOICEDQUANTITY;
    temp.shippedQuantity = json.SHIPPEDQUANTITY;
    temp.quantityToShip = json.QUANTITYTOSHIP;
    temp.replacedQuantity = json.REPLACEDQUANTITY;
    temp.grossAmountInvoiced = json.GROSSAMOUNTINVOICED;
    temp.reweightingValue = json.REWEIGHTINGVALUE;
    temp.packingWeight = json.PACKINGWEIGHT;
    temp.ipiValue = json.IPIVALUE;
    temp.ipiBaseValue = json.IPIBASEVALUE;
    temp.stValue = json.STVALUE;
    temp.baseStValue = json.BASESTVALUE;
    temp.stMargin = json.STMARGIN;
    temp.stockQuantity = json.STOCKQUANTITY;
    temp.ipiPercentage = json.IPIPERCENTAGE;
    temp.stateIcmsBasePercentage = json.STATEICMSBASEPERCENTAGE;
    temp.stateIcmsBaseValue = json.STATEICMSBASEVALUE;
    temp.stateIcmsValue = json.STATEICMSVALUE;
    temp.targetStateIcmsBasePercentage = json.TARGETSTATEICMSBASEPERCENTAGE;
    temp.targetStateIcmsBaseValue = json.TARGETSTATEICMSBASEVALUE;
    temp.targetStateIcmsPercentage = json.TARGETSTATEICMSPERCENTAGE;
    temp.targetStateIcmsValue = json.TARGETSTATEICMSVALUE;
    temp.taxationId = json.TAXATIONID;
    temp.batch = json.BATCH;

    return temp;
  }
  
  static toSend(item: OrderItem, itemNumber: number): any {
    var temp: any = {};
    temp.itemNumber = itemNumber;
    temp.productCode = item.productId;
    temp.productClasCode = item.classificationId;
    temp.quantity = item.quantity;
    temp.measurementUnitQuantity = item.measurementUnitQuantity;
    temp.measurementUnitDescription = item.measurementUnitDescription;
    temp.measurementUnit = item.measurementUnitInitials;
    temp.price = item.price;
    temp.discount = 0;
    temp.value = (item.price * item.quantity * item.measurementUnitQuantity);
    temp.total = (item.price * item.quantity * item.measurementUnitQuantity);
    return temp;
  }

  static fromCheckPriceProduct(product: CheckPriceProduct, cartProduct: CartProduct): OrderItem {
    var temp = new OrderItem();
    temp.productId = product.productCode;
    temp.classificationId = product.productClasCode;
    temp.quantity = product.quantity;
    temp.productName = cartProduct.item.name;
    temp.measurementUnitInitials = cartProduct.cartMeasurementUnit.measurementInitials;
    temp.price = cartProduct.item.price;
    return temp;
  }

}
